import * as io from "io-ts";
import type { ActiveAnalysis } from "../../../../../api/useActiveAnalysesStream";

/**
 * @description
 * Analysis columns.
 *
 * @see {/projects/:projectId(uuid)/active-analyses}
 */
export const ActiveAnalysisColumns = io.keyof({
  date: null,
  group: null,
  isPublished: null,
  label: null,
  status: null,
});

export type ActiveAnalysisColumnsT = keyof Pick<
  ActiveAnalysis,
  io.TypeOf<typeof ActiveAnalysisColumns>
>;
